import { useCurrentBreakpoint } from '@travel-frontend/core';
export const usePhoneNumberNew = config => {
  const currentBreakpoint = useCurrentBreakpoint();
  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  return config?.[currentBreakpoint] || config?.lg; // TODO mach schöner
};